import * as React from 'react';
import { IDropDownMenuProps } from '../../../DropDownMenu.types';
import DropDownMenuBase from '../../DropDownMenuBase';
import MenuButton from '../../../../MenuButton/viewer/skinComps/ShinyMenuIIButtonNSkin/ShinyMenuIIButtonNSkin';
import styles from './ShinyMenuIIButtonSkin.scss';

const ShinyMenuIIButtonSkin: React.FC<IDropDownMenuProps> = props => {
  return <DropDownMenuBase {...props} styles={styles} Button={MenuButton} />;
};

export default ShinyMenuIIButtonSkin;
